import { Location } from '@angular/common';
import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-missing',
    templateUrl: './application-missing.component.html',
    styleUrls: ['./application-missing.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationMissingComponent implements OnInit {
    constructor(
        private navController: NavController,
        private location: Location,
        private router: Router
    ) {}

    ngOnInit() {/* empty */}

    search = () => {
        const newUrl = '/search';
        const url = this.router.createUrlTree([`${newUrl}`]).toString();
        this.location.replaceState(url);
        this.navController.navigateRoot(['/search']);
    };
}
